import NavbarContentItem from '../../NavbarContentItem';
import * as S from '../../styles';

type Offer = {
  svg: string;
  links: unknown;
};
interface PropsActiveTab {
  isActive: boolean;
  newsTabOffer: Offer;
  setOpen: (boolean) => void;
  setOption: (boolean) => void;
}
export default function OfferTab({ isActive, newsTabOffer, setOpen, setOption }: PropsActiveTab) {
  return (
    <S.ListNavbar className={isActive && 'show'}>
      <S.ListTitle>CANALTECH OFERTAS</S.ListTitle>
      {Object.entries(newsTabOffer.links).map(link => (
        <NavbarContentItem link={link} setOpen={x => setOpen(x)} setOption={x => setOption(x)} key={link[0]} />
      ))}
    </S.ListNavbar>
  );
}
